import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";
import { components } from "./components";

declare module "@mui/material/styles" {
  interface Theme {
    tokens: typeof tokens;
  }
  interface ThemeOptions {
    tokens?: typeof tokens;
  }
}

export const appTheme = createTheme({
  tokens,
  /** 6px unit — denser than default 8px (desktop-app density) */
  spacing: 6,
  palette: {
    mode: "light",
    primary: {
      main: tokens.colors.primary.main,
      light: tokens.colors.primary.light,
      dark: tokens.colors.primary.dark,
      contrastText: tokens.colors.primary.contrast,
    },
    secondary: {
      main: tokens.colors.secondary.main,
      light: tokens.colors.secondary.light,
      dark: tokens.colors.secondary.dark,
      contrastText: tokens.colors.secondary.contrast,
    },
    success: {
      main: tokens.colors.success.main,
      light: tokens.colors.success.light,
      contrastText: "#FFFFFF",
    },
    warning: {
      main: tokens.colors.warning.main,
      light: tokens.colors.warning.light,
      contrastText: "#FFFFFF",
    },
    error: {
      main: tokens.colors.error.main,
      light: tokens.colors.error.light,
      contrastText: "#FFFFFF",
    },
    info: {
      main: tokens.colors.info.main,
      light: tokens.colors.info.light,
      contrastText: "#FFFFFF",
    },
    background: {
      default: tokens.colors.neutral[50],
      paper: "#FFFFFF",
    },
    text: {
      primary: tokens.colors.neutral[900],
      secondary: tokens.colors.neutral[500],
    },
    divider: tokens.colors.neutral[200],
  },
  typography: {
    fontFamily: tokens.fontFamily,
    fontSize: 15,
    htmlFontSize: 15,
    h1: { fontSize: "1.625rem", fontWeight: 700, lineHeight: 1.25 },
    h2: { fontSize: "1.475rem", fontWeight: 700, lineHeight: 1.25 },
    h3: { fontSize: "1.325rem", fontWeight: 700, lineHeight: 1.3 },
    h4: {
      fontSize: "1.175rem",
      fontWeight: 650,
      letterSpacing: "-0.01em",
      color: tokens.colors.neutral[900],
      lineHeight: 1.3,
    },
    h5: { fontSize: "1.075rem", fontWeight: 650, letterSpacing: "-0.01em", lineHeight: 1.3 },
    h6: { fontSize: "1rem", fontWeight: 650, lineHeight: 1.35 },
    subtitle1: { fontSize: "0.9375rem", fontWeight: 600, lineHeight: 1.4 },
    subtitle2: { fontSize: "0.875rem", fontWeight: 600, lineHeight: 1.4 },
    body1: { fontSize: "0.9375rem", lineHeight: 1.45 },
    body2: { fontSize: "0.875rem", lineHeight: 1.45 },
    caption: { fontSize: "0.8125rem", lineHeight: 1.4 },
    button: {
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: "none",
      lineHeight: 1.4,
    },
    overline: {
      fontWeight: 600,
      letterSpacing: "0.05em",
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components,
});

export const primaryGradient = `linear-gradient(135deg, ${tokens.colors.primary.dark} 0%, ${tokens.colors.primary.main} 55%, ${tokens.colors.primary.light} 100%)`;

export const pageBackground = () => tokens.colors.neutral[50];

export { tokens };
